import(/* webpackMode: "eager", webpackExports: ["StudentManageView"] */ "/web/src/sections/sub-pages/manage/student/view/student-manage-view.tsx");
